export default "<audio controls>\n  <source [src]=\"src\" type=\"audio/mpeg\">\n</audio>"